export default "__VITE_ASSET__QEkvbw3s__"